import React from "react";
import { useQuery } from "react-query";
import { ExportJob } from "types";
import { api } from "../../api/api";
import { ExportJobModal } from "../Common/ExportJobModal";

interface ExportTransactionsModalProps {
    isOpen: boolean;
    onClose: (e: any) => void;
    params: any;
}

export const ExportTransactionsModal = ({ isOpen, onClose, params }: ExportTransactionsModalProps) => {
    return isOpen ? <ModalContent isOpen={isOpen} params={params} onClose={onClose} /> : null;
};

const ModalContent = ({ isOpen, onClose, params }: ExportTransactionsModalProps) => {
    const { data: job } = useQuery<ExportJob>(
        ["transactions", "collection", params],
        async () => {
            const { data } = await api.get<ExportJob>("/transactions", { params });
            return data;
        },
        { enabled: isOpen },
    );

    return job ? <ExportJobModal isOpen={isOpen} job={job} onClose={onClose} /> : null;
};
